import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact-section',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './contact-section.html',
  styleUrl: './contact-section.scss',
})
export class ContactSection {
  contactStep: 'name' | 'email' = 'name';

  contactName = '';
  contactEmail = '';

  nextContactStep(): void {
    if (this.contactStep === 'name') {
      if (!this.contactName.trim()) {
        return;
      }

      this.contactStep = 'email';
      return;
    }

    if (!this.contactEmail.trim()) {
      return;
    }

    // Form submission will be connected when the feedback API is ready.
  }
}
